export class EmployeeRoleMap {
    ID:number=0;
    EMPLOYEE_ID:number=0;
    ROLE_ID:number; 
    STATUS:boolean=true;
     
}

 